import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '@@/ui/primitives/button';
import { WizardStep } from './wizard-stepper';

export function WizardNavigation(props: {
  currentStep: WizardStep;
  canProceed: boolean;
  onBack: () => void;
  onNext: () => void;
}) {
  const getNextButtonLabel = () => {
    switch (props.currentStep) {
      case WizardStep.TYPE:
        return 'Content';
      case WizardStep.MESSAGE:
        return 'Schedule';
      case WizardStep.SCHEDULE:
        return 'Contact List';
      case WizardStep.CONTACT_LIST:
        return 'Review';
      case WizardStep.REVIEW:
        return 'Launch';
      default:
        return 'Next';
    }
  };

  return (
    <div className='flex items-center gap-3 pt-6'>
      <Button variant='outline' onClick={props.onBack}>
        <ArrowLeft className='w-4 h-4' />
        Back
      </Button>
      <Button onClick={props.onNext} disabled={!props.canProceed}>
        {getNextButtonLabel()}
        <ArrowRight className='w-4 h-4' />
      </Button>
    </div>
  );
}
